import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { RealProblem } from './components/RealProblem';
import { WhyFail } from './components/WhyFail';
import { Solution } from './components/Solution';
import { About } from './components/About';
import { WhatYouGet } from './components/WhatYouGet';
import { Testimonials } from './components/Testimonials';
import { ForYou } from './components/ForYou';
import { Urgency } from './components/Urgency';
import { AddOns } from './components/AddOns';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-slate-300 font-sans selection:bg-brand-accent/30 selection:text-amber-200" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <RealProblem data-id="element-5" />
        <WhyFail data-id="element-6" />
        <Solution data-id="element-7" />
        <About data-id="element-8" />
        <WhatYouGet data-id="element-9" />
        <Testimonials data-id="element-10" />
        <ForYou data-id="element-11" />
        <Urgency data-id="element-12" />
        <AddOns data-id="element-13" />
        <FAQ data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
      <PurchaseToast data-id="element-17" />
    </div>;
}